var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"contactusaction"},[_c('Container',[_c('div',{staticClass:"contactusaction__form"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('ButtonBox',{attrs:{"to":{ name: 'contato' },"outline":"fill"}},[_vm._v("\n                  Contato\n                ")])],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }